module.exports = __webpack_public_path__ + "img/bannerRed.386e791c.jpg";